// roomObjects.js
// Hotspot positions ported from escape_peace-old/escape1.php (desktop,
// viewBox 0 0 1920 911) and escape_mob.php (mobile portrait, viewBox
// 0 0 414 896). Each PHP hotspot is an absolutely-positioned <image
// transform="translate(x y)" width=".." height=".."> inside those SVGs;
// the percentages below are those same boxes converted to %-of-viewBox so
// they scale with the room image at any screen size (see phase-2 report for
// the extraction method — the source SVGs were not modified).
import roomDesktopMirror from '../../../assets/escape-to-inner-peace/room/room-desktop-mirror.png';
import roomDesktopBook from '../../../assets/escape-to-inner-peace/room/room-desktop-book.png';
import roomDesktopTablet from '../../../assets/escape-to-inner-peace/room/room-desktop-tablet.png';
import roomDesktopSafe from '../../../assets/escape-to-inner-peace/room/room-desktop-safe.png';
import roomDesktopChest from '../../../assets/escape-to-inner-peace/room/room-desktop-chest.png';

import roomMobileMirror from '../../../assets/escape-to-inner-peace/room/room-mobile-mirror.png';
import roomMobileBook from '../../../assets/escape-to-inner-peace/room/room-mobile-book.png';
import roomMobileTablet from '../../../assets/escape-to-inner-peace/room/room-mobile-tablet.png';
import roomMobileSafe from '../../../assets/escape-to-inner-peace/room/room-mobile-safe.png';
import roomMobileChest from '../../../assets/escape-to-inner-peace/room/room-mobile-chest.png';

export const ROOM_OBJECTS = [
  {
    id: 'mirror',
    label: 'Mirror',
    desktop: { image: roomDesktopMirror, left: 69.68, top: 3.44, width: 13.07, height: 39.85 },
    mobile: { image: roomMobileMirror, left: 80.88, top: 38.29, width: 19.04, height: 17.93 },
  },
  {
    id: 'book',
    label: 'Book',
    desktop: { image: roomDesktopBook, left: 49.48, top: 46.13, width: 7.81, height: 5.93 },
    mobile: { image: roomMobileBook, left: 54.49, top: 58.83, width: 13.04, height: 2.23 },
  },
  {
    id: 'tablet',
    label: 'Tablet',
    desktop: { image: roomDesktopTablet, left: 77.76, top: 79.4, width: 5.57, height: 4.61 },
    mobile: { image: roomMobileTablet, left: 79.45, top: 74.52, width: 9.18, height: 1.79 },
  },
  {
    id: 'safe',
    label: 'Safe',
    desktop: { image: roomDesktopSafe, left: 20.8, top: 49.27, width: 8.85, height: 20.42 },
    mobile: { image: roomMobileSafe, left: 14.96, top: 60.28, width: 16.67, height: 8.82 },
  },
  {
    id: 'chest',
    label: 'Chest',
    desktop: { image: roomDesktopChest, left: 4.99, top: 39.98, width: 9.74, height: 10.43 },
    mobile: { image: roomMobileChest, left: 0.02, top: 56.28, width: 9.66, height: 5.13 },
  },
];
